import { render, staticRenderFns } from "./CarDetails.vue?vue&type=template&id=1c5fd264&scoped=true"
import script from "./CarDetails.vue?vue&type=script&lang=js"
export * from "./CarDetails.vue?vue&type=script&lang=js"
import style0 from "./CarDetails.vue?vue&type=style&index=0&id=1c5fd264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5fd264",
  null
  
)

export default component.exports